/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as AdminLoginRouteImport } from './routes/admin/Login'
import { Route as ChatCreditKeyIndexRouteImport } from './routes/chatCreditKey/index'
import { Route as WorkspaceIndexRouteImport } from './routes/workspace/index'
import { Route as AdminUserManagerIndexRouteImport } from './routes/admin/userManager/index'
import { Route as AdminUserManagerUserIdRouteImport } from './routes/admin/userManager/$userId'
import { Route as AdminWorkspaceManagerIndexRouteImport } from './routes/admin/workspaceManager/index'
import { Route as WorkspaceWorkspaceIdIndexRouteImport } from './routes/workspace/$workspaceId/index'
import { Route as WorkspaceWorkspaceIdSettingsRouteImport } from './routes/workspace/$workspaceId/settings'
import { Route as WorkspaceWorkspaceIdBotProviderIndexRouteImport } from './routes/workspace/$workspaceId/botProvider/index'
import { Route as WorkspaceWorkspaceIdChatBotDataIndexRouteImport } from './routes/workspace/$workspaceId/chatBotData/index'
import { Route as WorkspaceWorkspaceIdChatEvaluationTestSetIndexRouteImport } from './routes/workspace/$workspaceId/chatEvaluationTestSet/index'
import { Route as WorkspaceWorkspaceIdEmbeddingCollectionIndexRouteImport } from './routes/workspace/$workspaceId/embeddingCollection/index'
import { Route as WorkspaceWorkspaceIdNotificationSettingsIndexRouteImport } from './routes/workspace/$workspaceId/notificationSettings/index'
import { Route as WorkspaceWorkspaceIdSettingsInfoRouteImport } from './routes/workspace/$workspaceId/settings/info'
import { Route as WorkspaceWorkspaceIdSettingsPendingUsersRouteImport } from './routes/workspace/$workspaceId/settings/pendingUsers'
import { Route as WorkspaceWorkspaceIdSettingsUsersRouteImport } from './routes/workspace/$workspaceId/settings/users'
import { Route as WorkspaceWorkspaceIdBotProviderBotProviderIdIndexRouteImport } from './routes/workspace/$workspaceId/botProvider/$botProviderId/index'
import { Route as WorkspaceWorkspaceIdBotProviderBotProviderIdFeedbackRouteImport } from './routes/workspace/$workspaceId/botProvider/$botProviderId/feedback'
import { Route as WorkspaceWorkspaceIdBotProviderBotProviderIdHistoryRouteImport } from './routes/workspace/$workspaceId/botProvider/$botProviderId/history'
import { Route as WorkspaceWorkspaceIdChatBotDataChatBotDataIdIndexRouteImport } from './routes/workspace/$workspaceId/chatBotData/$chatBotDataId/index'
import { Route as WorkspaceWorkspaceIdChatBotDataChatBotDataIdChatRouteImport } from './routes/workspace/$workspaceId/chatBotData/$chatBotDataId/chat'
import { Route as WorkspaceWorkspaceIdChatBotDataChatBotDataIdPublicChatRouteImport } from './routes/workspace/$workspaceId/chatBotData/$chatBotDataId/publicChat'
import { Route as WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdIndexRouteImport } from './routes/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/index'
import { Route as WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdIndexRouteImport } from './routes/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/index'
import { Route as WorkspaceWorkspaceIdBotProviderBotProviderIdUserUserIdRouteImport } from './routes/workspace/$workspaceId/botProvider/$botProviderId/user/$userId'
import { Route as WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdDataIdIndexRouteImport } from './routes/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/$dataId/index'
import { Route as WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdIndexRouteImport } from './routes/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/index'
import { Route as WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdReportRouteImport } from './routes/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/report'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/admin/Login',
  path: '/admin/Login',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatCreditKeyIndexRoute = ChatCreditKeyIndexRouteImport.update({
  id: '/chatCreditKey/',
  path: '/chatCreditKey/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceIndexRoute = WorkspaceIndexRouteImport.update({
  id: '/workspace/',
  path: '/workspace/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUserManagerIndexRoute = AdminUserManagerIndexRouteImport.update({
  id: '/admin/userManager/',
  path: '/admin/userManager/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUserManagerUserIdRoute = AdminUserManagerUserIdRouteImport.update({
  id: '/admin/userManager/$userId',
  path: '/admin/userManager/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWorkspaceManagerIndexRoute =
  AdminWorkspaceManagerIndexRouteImport.update({
    id: '/admin/workspaceManager/',
    path: '/admin/workspaceManager/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceWorkspaceIdIndexRoute =
  WorkspaceWorkspaceIdIndexRouteImport.update({
    id: '/workspace/$workspaceId/',
    path: '/workspace/$workspaceId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceWorkspaceIdSettingsRoute =
  WorkspaceWorkspaceIdSettingsRouteImport.update({
    id: '/workspace/$workspaceId/settings',
    path: '/workspace/$workspaceId/settings',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceWorkspaceIdBotProviderIndexRoute =
  WorkspaceWorkspaceIdBotProviderIndexRouteImport.update({
    id: '/workspace/$workspaceId/botProvider/',
    path: '/workspace/$workspaceId/botProvider/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceWorkspaceIdChatBotDataIndexRoute =
  WorkspaceWorkspaceIdChatBotDataIndexRouteImport.update({
    id: '/workspace/$workspaceId/chatBotData/',
    path: '/workspace/$workspaceId/chatBotData/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceWorkspaceIdChatEvaluationTestSetIndexRoute =
  WorkspaceWorkspaceIdChatEvaluationTestSetIndexRouteImport.update({
    id: '/workspace/$workspaceId/chatEvaluationTestSet/',
    path: '/workspace/$workspaceId/chatEvaluationTestSet/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceWorkspaceIdEmbeddingCollectionIndexRoute =
  WorkspaceWorkspaceIdEmbeddingCollectionIndexRouteImport.update({
    id: '/workspace/$workspaceId/embeddingCollection/',
    path: '/workspace/$workspaceId/embeddingCollection/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceWorkspaceIdNotificationSettingsIndexRoute =
  WorkspaceWorkspaceIdNotificationSettingsIndexRouteImport.update({
    id: '/workspace/$workspaceId/notificationSettings/',
    path: '/workspace/$workspaceId/notificationSettings/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceWorkspaceIdSettingsInfoRoute =
  WorkspaceWorkspaceIdSettingsInfoRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => WorkspaceWorkspaceIdSettingsRoute,
  } as any)
const WorkspaceWorkspaceIdSettingsPendingUsersRoute =
  WorkspaceWorkspaceIdSettingsPendingUsersRouteImport.update({
    id: '/pendingUsers',
    path: '/pendingUsers',
    getParentRoute: () => WorkspaceWorkspaceIdSettingsRoute,
  } as any)
const WorkspaceWorkspaceIdSettingsUsersRoute =
  WorkspaceWorkspaceIdSettingsUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => WorkspaceWorkspaceIdSettingsRoute,
  } as any)
const WorkspaceWorkspaceIdBotProviderBotProviderIdIndexRoute =
  WorkspaceWorkspaceIdBotProviderBotProviderIdIndexRouteImport.update({
    id: '/workspace/$workspaceId/botProvider/$botProviderId/',
    path: '/workspace/$workspaceId/botProvider/$botProviderId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceWorkspaceIdBotProviderBotProviderIdFeedbackRoute =
  WorkspaceWorkspaceIdBotProviderBotProviderIdFeedbackRouteImport.update({
    id: '/workspace/$workspaceId/botProvider/$botProviderId/feedback',
    path: '/workspace/$workspaceId/botProvider/$botProviderId/feedback',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceWorkspaceIdBotProviderBotProviderIdHistoryRoute =
  WorkspaceWorkspaceIdBotProviderBotProviderIdHistoryRouteImport.update({
    id: '/workspace/$workspaceId/botProvider/$botProviderId/history',
    path: '/workspace/$workspaceId/botProvider/$botProviderId/history',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceWorkspaceIdChatBotDataChatBotDataIdIndexRoute =
  WorkspaceWorkspaceIdChatBotDataChatBotDataIdIndexRouteImport.update({
    id: '/workspace/$workspaceId/chatBotData/$chatBotDataId/',
    path: '/workspace/$workspaceId/chatBotData/$chatBotDataId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceWorkspaceIdChatBotDataChatBotDataIdChatRoute =
  WorkspaceWorkspaceIdChatBotDataChatBotDataIdChatRouteImport.update({
    id: '/workspace/$workspaceId/chatBotData/$chatBotDataId/chat',
    path: '/workspace/$workspaceId/chatBotData/$chatBotDataId/chat',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceWorkspaceIdChatBotDataChatBotDataIdPublicChatRoute =
  WorkspaceWorkspaceIdChatBotDataChatBotDataIdPublicChatRouteImport.update({
    id: '/workspace/$workspaceId/chatBotData/$chatBotDataId/publicChat',
    path: '/workspace/$workspaceId/chatBotData/$chatBotDataId/publicChat',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdIndexRoute =
  WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdIndexRouteImport.update(
    {
      id: '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/',
      path: '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdIndexRoute =
  WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdIndexRouteImport.update(
    {
      id: '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/',
      path: '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const WorkspaceWorkspaceIdBotProviderBotProviderIdUserUserIdRoute =
  WorkspaceWorkspaceIdBotProviderBotProviderIdUserUserIdRouteImport.update({
    id: '/workspace/$workspaceId/botProvider/$botProviderId/user/$userId',
    path: '/workspace/$workspaceId/botProvider/$botProviderId/user/$userId',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdDataIdIndexRoute =
  WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdDataIdIndexRouteImport.update(
    {
      id: '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/$dataId/',
      path: '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/$dataId/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdIndexRoute =
  WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdIndexRouteImport.update(
    {
      id: '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/',
      path: '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdReportRoute =
  WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdReportRouteImport.update(
    {
      id: '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/report',
      path: '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/report',
      getParentRoute: () => rootRouteImport,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRoute
  '/admin/Login': typeof AdminLoginRoute
  '/chatCreditKey/': typeof ChatCreditKeyIndexRoute
  '/workspace/': typeof WorkspaceIndexRoute
  '/admin/userManager/$userId': typeof AdminUserManagerUserIdRoute
  '/workspace/$workspaceId/settings': typeof WorkspaceWorkspaceIdSettingsRouteWithChildren
  '/admin/userManager/': typeof AdminUserManagerIndexRoute
  '/admin/workspaceManager/': typeof AdminWorkspaceManagerIndexRoute
  '/workspace/$workspaceId/': typeof WorkspaceWorkspaceIdIndexRoute
  '/workspace/$workspaceId/settings/info': typeof WorkspaceWorkspaceIdSettingsInfoRoute
  '/workspace/$workspaceId/settings/pendingUsers': typeof WorkspaceWorkspaceIdSettingsPendingUsersRoute
  '/workspace/$workspaceId/settings/users': typeof WorkspaceWorkspaceIdSettingsUsersRoute
  '/workspace/$workspaceId/botProvider/': typeof WorkspaceWorkspaceIdBotProviderIndexRoute
  '/workspace/$workspaceId/chatBotData/': typeof WorkspaceWorkspaceIdChatBotDataIndexRoute
  '/workspace/$workspaceId/chatEvaluationTestSet/': typeof WorkspaceWorkspaceIdChatEvaluationTestSetIndexRoute
  '/workspace/$workspaceId/embeddingCollection/': typeof WorkspaceWorkspaceIdEmbeddingCollectionIndexRoute
  '/workspace/$workspaceId/notificationSettings/': typeof WorkspaceWorkspaceIdNotificationSettingsIndexRoute
  '/workspace/$workspaceId/botProvider/$botProviderId/feedback': typeof WorkspaceWorkspaceIdBotProviderBotProviderIdFeedbackRoute
  '/workspace/$workspaceId/botProvider/$botProviderId/history': typeof WorkspaceWorkspaceIdBotProviderBotProviderIdHistoryRoute
  '/workspace/$workspaceId/chatBotData/$chatBotDataId/chat': typeof WorkspaceWorkspaceIdChatBotDataChatBotDataIdChatRoute
  '/workspace/$workspaceId/chatBotData/$chatBotDataId/publicChat': typeof WorkspaceWorkspaceIdChatBotDataChatBotDataIdPublicChatRoute
  '/workspace/$workspaceId/botProvider/$botProviderId/': typeof WorkspaceWorkspaceIdBotProviderBotProviderIdIndexRoute
  '/workspace/$workspaceId/chatBotData/$chatBotDataId/': typeof WorkspaceWorkspaceIdChatBotDataChatBotDataIdIndexRoute
  '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/': typeof WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdIndexRoute
  '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/': typeof WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdIndexRoute
  '/workspace/$workspaceId/botProvider/$botProviderId/user/$userId': typeof WorkspaceWorkspaceIdBotProviderBotProviderIdUserUserIdRoute
  '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/$dataId/': typeof WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdDataIdIndexRoute
  '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/report': typeof WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdReportRoute
  '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/': typeof WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRoute
  '/admin/Login': typeof AdminLoginRoute
  '/chatCreditKey': typeof ChatCreditKeyIndexRoute
  '/workspace': typeof WorkspaceIndexRoute
  '/admin/userManager/$userId': typeof AdminUserManagerUserIdRoute
  '/workspace/$workspaceId/settings': typeof WorkspaceWorkspaceIdSettingsRouteWithChildren
  '/admin/userManager': typeof AdminUserManagerIndexRoute
  '/admin/workspaceManager': typeof AdminWorkspaceManagerIndexRoute
  '/workspace/$workspaceId': typeof WorkspaceWorkspaceIdIndexRoute
  '/workspace/$workspaceId/settings/info': typeof WorkspaceWorkspaceIdSettingsInfoRoute
  '/workspace/$workspaceId/settings/pendingUsers': typeof WorkspaceWorkspaceIdSettingsPendingUsersRoute
  '/workspace/$workspaceId/settings/users': typeof WorkspaceWorkspaceIdSettingsUsersRoute
  '/workspace/$workspaceId/botProvider': typeof WorkspaceWorkspaceIdBotProviderIndexRoute
  '/workspace/$workspaceId/chatBotData': typeof WorkspaceWorkspaceIdChatBotDataIndexRoute
  '/workspace/$workspaceId/chatEvaluationTestSet': typeof WorkspaceWorkspaceIdChatEvaluationTestSetIndexRoute
  '/workspace/$workspaceId/embeddingCollection': typeof WorkspaceWorkspaceIdEmbeddingCollectionIndexRoute
  '/workspace/$workspaceId/notificationSettings': typeof WorkspaceWorkspaceIdNotificationSettingsIndexRoute
  '/workspace/$workspaceId/botProvider/$botProviderId/feedback': typeof WorkspaceWorkspaceIdBotProviderBotProviderIdFeedbackRoute
  '/workspace/$workspaceId/botProvider/$botProviderId/history': typeof WorkspaceWorkspaceIdBotProviderBotProviderIdHistoryRoute
  '/workspace/$workspaceId/chatBotData/$chatBotDataId/chat': typeof WorkspaceWorkspaceIdChatBotDataChatBotDataIdChatRoute
  '/workspace/$workspaceId/chatBotData/$chatBotDataId/publicChat': typeof WorkspaceWorkspaceIdChatBotDataChatBotDataIdPublicChatRoute
  '/workspace/$workspaceId/botProvider/$botProviderId': typeof WorkspaceWorkspaceIdBotProviderBotProviderIdIndexRoute
  '/workspace/$workspaceId/chatBotData/$chatBotDataId': typeof WorkspaceWorkspaceIdChatBotDataChatBotDataIdIndexRoute
  '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId': typeof WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdIndexRoute
  '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId': typeof WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdIndexRoute
  '/workspace/$workspaceId/botProvider/$botProviderId/user/$userId': typeof WorkspaceWorkspaceIdBotProviderBotProviderIdUserUserIdRoute
  '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/$dataId': typeof WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdDataIdIndexRoute
  '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/report': typeof WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdReportRoute
  '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId': typeof WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/settings': typeof SettingsRoute
  '/admin/Login': typeof AdminLoginRoute
  '/chatCreditKey/': typeof ChatCreditKeyIndexRoute
  '/workspace/': typeof WorkspaceIndexRoute
  '/admin/userManager/$userId': typeof AdminUserManagerUserIdRoute
  '/workspace/$workspaceId/settings': typeof WorkspaceWorkspaceIdSettingsRouteWithChildren
  '/admin/userManager/': typeof AdminUserManagerIndexRoute
  '/admin/workspaceManager/': typeof AdminWorkspaceManagerIndexRoute
  '/workspace/$workspaceId/': typeof WorkspaceWorkspaceIdIndexRoute
  '/workspace/$workspaceId/settings/info': typeof WorkspaceWorkspaceIdSettingsInfoRoute
  '/workspace/$workspaceId/settings/pendingUsers': typeof WorkspaceWorkspaceIdSettingsPendingUsersRoute
  '/workspace/$workspaceId/settings/users': typeof WorkspaceWorkspaceIdSettingsUsersRoute
  '/workspace/$workspaceId/botProvider/': typeof WorkspaceWorkspaceIdBotProviderIndexRoute
  '/workspace/$workspaceId/chatBotData/': typeof WorkspaceWorkspaceIdChatBotDataIndexRoute
  '/workspace/$workspaceId/chatEvaluationTestSet/': typeof WorkspaceWorkspaceIdChatEvaluationTestSetIndexRoute
  '/workspace/$workspaceId/embeddingCollection/': typeof WorkspaceWorkspaceIdEmbeddingCollectionIndexRoute
  '/workspace/$workspaceId/notificationSettings/': typeof WorkspaceWorkspaceIdNotificationSettingsIndexRoute
  '/workspace/$workspaceId/botProvider/$botProviderId/feedback': typeof WorkspaceWorkspaceIdBotProviderBotProviderIdFeedbackRoute
  '/workspace/$workspaceId/botProvider/$botProviderId/history': typeof WorkspaceWorkspaceIdBotProviderBotProviderIdHistoryRoute
  '/workspace/$workspaceId/chatBotData/$chatBotDataId/chat': typeof WorkspaceWorkspaceIdChatBotDataChatBotDataIdChatRoute
  '/workspace/$workspaceId/chatBotData/$chatBotDataId/publicChat': typeof WorkspaceWorkspaceIdChatBotDataChatBotDataIdPublicChatRoute
  '/workspace/$workspaceId/botProvider/$botProviderId/': typeof WorkspaceWorkspaceIdBotProviderBotProviderIdIndexRoute
  '/workspace/$workspaceId/chatBotData/$chatBotDataId/': typeof WorkspaceWorkspaceIdChatBotDataChatBotDataIdIndexRoute
  '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/': typeof WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdIndexRoute
  '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/': typeof WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdIndexRoute
  '/workspace/$workspaceId/botProvider/$botProviderId/user/$userId': typeof WorkspaceWorkspaceIdBotProviderBotProviderIdUserUserIdRoute
  '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/$dataId/': typeof WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdDataIdIndexRoute
  '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/report': typeof WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdReportRoute
  '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/': typeof WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/admin/Login'
    | '/chatCreditKey/'
    | '/workspace/'
    | '/admin/userManager/$userId'
    | '/workspace/$workspaceId/settings'
    | '/admin/userManager/'
    | '/admin/workspaceManager/'
    | '/workspace/$workspaceId/'
    | '/workspace/$workspaceId/settings/info'
    | '/workspace/$workspaceId/settings/pendingUsers'
    | '/workspace/$workspaceId/settings/users'
    | '/workspace/$workspaceId/botProvider/'
    | '/workspace/$workspaceId/chatBotData/'
    | '/workspace/$workspaceId/chatEvaluationTestSet/'
    | '/workspace/$workspaceId/embeddingCollection/'
    | '/workspace/$workspaceId/notificationSettings/'
    | '/workspace/$workspaceId/botProvider/$botProviderId/feedback'
    | '/workspace/$workspaceId/botProvider/$botProviderId/history'
    | '/workspace/$workspaceId/chatBotData/$chatBotDataId/chat'
    | '/workspace/$workspaceId/chatBotData/$chatBotDataId/publicChat'
    | '/workspace/$workspaceId/botProvider/$botProviderId/'
    | '/workspace/$workspaceId/chatBotData/$chatBotDataId/'
    | '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/'
    | '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/'
    | '/workspace/$workspaceId/botProvider/$botProviderId/user/$userId'
    | '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/$dataId/'
    | '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/report'
    | '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/settings'
    | '/admin/Login'
    | '/chatCreditKey'
    | '/workspace'
    | '/admin/userManager/$userId'
    | '/workspace/$workspaceId/settings'
    | '/admin/userManager'
    | '/admin/workspaceManager'
    | '/workspace/$workspaceId'
    | '/workspace/$workspaceId/settings/info'
    | '/workspace/$workspaceId/settings/pendingUsers'
    | '/workspace/$workspaceId/settings/users'
    | '/workspace/$workspaceId/botProvider'
    | '/workspace/$workspaceId/chatBotData'
    | '/workspace/$workspaceId/chatEvaluationTestSet'
    | '/workspace/$workspaceId/embeddingCollection'
    | '/workspace/$workspaceId/notificationSettings'
    | '/workspace/$workspaceId/botProvider/$botProviderId/feedback'
    | '/workspace/$workspaceId/botProvider/$botProviderId/history'
    | '/workspace/$workspaceId/chatBotData/$chatBotDataId/chat'
    | '/workspace/$workspaceId/chatBotData/$chatBotDataId/publicChat'
    | '/workspace/$workspaceId/botProvider/$botProviderId'
    | '/workspace/$workspaceId/chatBotData/$chatBotDataId'
    | '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId'
    | '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId'
    | '/workspace/$workspaceId/botProvider/$botProviderId/user/$userId'
    | '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/$dataId'
    | '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/report'
    | '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId'
  id:
    | '__root__'
    | '/'
    | '/settings'
    | '/admin/Login'
    | '/chatCreditKey/'
    | '/workspace/'
    | '/admin/userManager/$userId'
    | '/workspace/$workspaceId/settings'
    | '/admin/userManager/'
    | '/admin/workspaceManager/'
    | '/workspace/$workspaceId/'
    | '/workspace/$workspaceId/settings/info'
    | '/workspace/$workspaceId/settings/pendingUsers'
    | '/workspace/$workspaceId/settings/users'
    | '/workspace/$workspaceId/botProvider/'
    | '/workspace/$workspaceId/chatBotData/'
    | '/workspace/$workspaceId/chatEvaluationTestSet/'
    | '/workspace/$workspaceId/embeddingCollection/'
    | '/workspace/$workspaceId/notificationSettings/'
    | '/workspace/$workspaceId/botProvider/$botProviderId/feedback'
    | '/workspace/$workspaceId/botProvider/$botProviderId/history'
    | '/workspace/$workspaceId/chatBotData/$chatBotDataId/chat'
    | '/workspace/$workspaceId/chatBotData/$chatBotDataId/publicChat'
    | '/workspace/$workspaceId/botProvider/$botProviderId/'
    | '/workspace/$workspaceId/chatBotData/$chatBotDataId/'
    | '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/'
    | '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/'
    | '/workspace/$workspaceId/botProvider/$botProviderId/user/$userId'
    | '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/$dataId/'
    | '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/report'
    | '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SettingsRoute: typeof SettingsRoute
  AdminLoginRoute: typeof AdminLoginRoute
  ChatCreditKeyIndexRoute: typeof ChatCreditKeyIndexRoute
  WorkspaceIndexRoute: typeof WorkspaceIndexRoute
  AdminUserManagerUserIdRoute: typeof AdminUserManagerUserIdRoute
  WorkspaceWorkspaceIdSettingsRoute: typeof WorkspaceWorkspaceIdSettingsRouteWithChildren
  AdminUserManagerIndexRoute: typeof AdminUserManagerIndexRoute
  AdminWorkspaceManagerIndexRoute: typeof AdminWorkspaceManagerIndexRoute
  WorkspaceWorkspaceIdIndexRoute: typeof WorkspaceWorkspaceIdIndexRoute
  WorkspaceWorkspaceIdBotProviderIndexRoute: typeof WorkspaceWorkspaceIdBotProviderIndexRoute
  WorkspaceWorkspaceIdChatBotDataIndexRoute: typeof WorkspaceWorkspaceIdChatBotDataIndexRoute
  WorkspaceWorkspaceIdChatEvaluationTestSetIndexRoute: typeof WorkspaceWorkspaceIdChatEvaluationTestSetIndexRoute
  WorkspaceWorkspaceIdEmbeddingCollectionIndexRoute: typeof WorkspaceWorkspaceIdEmbeddingCollectionIndexRoute
  WorkspaceWorkspaceIdNotificationSettingsIndexRoute: typeof WorkspaceWorkspaceIdNotificationSettingsIndexRoute
  WorkspaceWorkspaceIdBotProviderBotProviderIdFeedbackRoute: typeof WorkspaceWorkspaceIdBotProviderBotProviderIdFeedbackRoute
  WorkspaceWorkspaceIdBotProviderBotProviderIdHistoryRoute: typeof WorkspaceWorkspaceIdBotProviderBotProviderIdHistoryRoute
  WorkspaceWorkspaceIdChatBotDataChatBotDataIdChatRoute: typeof WorkspaceWorkspaceIdChatBotDataChatBotDataIdChatRoute
  WorkspaceWorkspaceIdChatBotDataChatBotDataIdPublicChatRoute: typeof WorkspaceWorkspaceIdChatBotDataChatBotDataIdPublicChatRoute
  WorkspaceWorkspaceIdBotProviderBotProviderIdIndexRoute: typeof WorkspaceWorkspaceIdBotProviderBotProviderIdIndexRoute
  WorkspaceWorkspaceIdChatBotDataChatBotDataIdIndexRoute: typeof WorkspaceWorkspaceIdChatBotDataChatBotDataIdIndexRoute
  WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdIndexRoute: typeof WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdIndexRoute
  WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdIndexRoute: typeof WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdIndexRoute
  WorkspaceWorkspaceIdBotProviderBotProviderIdUserUserIdRoute: typeof WorkspaceWorkspaceIdBotProviderBotProviderIdUserUserIdRoute
  WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdDataIdIndexRoute: typeof WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdDataIdIndexRoute
  WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdReportRoute: typeof WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdReportRoute
  WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdIndexRoute: typeof WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/Login': {
      id: '/admin/Login'
      path: '/admin/Login'
      fullPath: '/admin/Login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chatCreditKey/': {
      id: '/chatCreditKey/'
      path: '/chatCreditKey'
      fullPath: '/chatCreditKey/'
      preLoaderRoute: typeof ChatCreditKeyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/': {
      id: '/workspace/'
      path: '/workspace'
      fullPath: '/workspace/'
      preLoaderRoute: typeof WorkspaceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/userManager/': {
      id: '/admin/userManager/'
      path: '/admin/userManager'
      fullPath: '/admin/userManager/'
      preLoaderRoute: typeof AdminUserManagerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/userManager/$userId': {
      id: '/admin/userManager/$userId'
      path: '/admin/userManager/$userId'
      fullPath: '/admin/userManager/$userId'
      preLoaderRoute: typeof AdminUserManagerUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/workspaceManager/': {
      id: '/admin/workspaceManager/'
      path: '/admin/workspaceManager'
      fullPath: '/admin/workspaceManager/'
      preLoaderRoute: typeof AdminWorkspaceManagerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/': {
      id: '/workspace/$workspaceId/'
      path: '/workspace/$workspaceId'
      fullPath: '/workspace/$workspaceId/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/settings': {
      id: '/workspace/$workspaceId/settings'
      path: '/workspace/$workspaceId/settings'
      fullPath: '/workspace/$workspaceId/settings'
      preLoaderRoute: typeof WorkspaceWorkspaceIdSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/botProvider/': {
      id: '/workspace/$workspaceId/botProvider/'
      path: '/workspace/$workspaceId/botProvider'
      fullPath: '/workspace/$workspaceId/botProvider/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdBotProviderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/chatBotData/': {
      id: '/workspace/$workspaceId/chatBotData/'
      path: '/workspace/$workspaceId/chatBotData'
      fullPath: '/workspace/$workspaceId/chatBotData/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdChatBotDataIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/chatEvaluationTestSet/': {
      id: '/workspace/$workspaceId/chatEvaluationTestSet/'
      path: '/workspace/$workspaceId/chatEvaluationTestSet'
      fullPath: '/workspace/$workspaceId/chatEvaluationTestSet/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdChatEvaluationTestSetIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/embeddingCollection/': {
      id: '/workspace/$workspaceId/embeddingCollection/'
      path: '/workspace/$workspaceId/embeddingCollection'
      fullPath: '/workspace/$workspaceId/embeddingCollection/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdEmbeddingCollectionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/notificationSettings/': {
      id: '/workspace/$workspaceId/notificationSettings/'
      path: '/workspace/$workspaceId/notificationSettings'
      fullPath: '/workspace/$workspaceId/notificationSettings/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdNotificationSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/settings/info': {
      id: '/workspace/$workspaceId/settings/info'
      path: '/info'
      fullPath: '/workspace/$workspaceId/settings/info'
      preLoaderRoute: typeof WorkspaceWorkspaceIdSettingsInfoRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdSettingsRoute
    }
    '/workspace/$workspaceId/settings/pendingUsers': {
      id: '/workspace/$workspaceId/settings/pendingUsers'
      path: '/pendingUsers'
      fullPath: '/workspace/$workspaceId/settings/pendingUsers'
      preLoaderRoute: typeof WorkspaceWorkspaceIdSettingsPendingUsersRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdSettingsRoute
    }
    '/workspace/$workspaceId/settings/users': {
      id: '/workspace/$workspaceId/settings/users'
      path: '/users'
      fullPath: '/workspace/$workspaceId/settings/users'
      preLoaderRoute: typeof WorkspaceWorkspaceIdSettingsUsersRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdSettingsRoute
    }
    '/workspace/$workspaceId/botProvider/$botProviderId/': {
      id: '/workspace/$workspaceId/botProvider/$botProviderId/'
      path: '/workspace/$workspaceId/botProvider/$botProviderId'
      fullPath: '/workspace/$workspaceId/botProvider/$botProviderId/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdBotProviderBotProviderIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/botProvider/$botProviderId/feedback': {
      id: '/workspace/$workspaceId/botProvider/$botProviderId/feedback'
      path: '/workspace/$workspaceId/botProvider/$botProviderId/feedback'
      fullPath: '/workspace/$workspaceId/botProvider/$botProviderId/feedback'
      preLoaderRoute: typeof WorkspaceWorkspaceIdBotProviderBotProviderIdFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/botProvider/$botProviderId/history': {
      id: '/workspace/$workspaceId/botProvider/$botProviderId/history'
      path: '/workspace/$workspaceId/botProvider/$botProviderId/history'
      fullPath: '/workspace/$workspaceId/botProvider/$botProviderId/history'
      preLoaderRoute: typeof WorkspaceWorkspaceIdBotProviderBotProviderIdHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/chatBotData/$chatBotDataId/': {
      id: '/workspace/$workspaceId/chatBotData/$chatBotDataId/'
      path: '/workspace/$workspaceId/chatBotData/$chatBotDataId'
      fullPath: '/workspace/$workspaceId/chatBotData/$chatBotDataId/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdChatBotDataChatBotDataIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/chatBotData/$chatBotDataId/chat': {
      id: '/workspace/$workspaceId/chatBotData/$chatBotDataId/chat'
      path: '/workspace/$workspaceId/chatBotData/$chatBotDataId/chat'
      fullPath: '/workspace/$workspaceId/chatBotData/$chatBotDataId/chat'
      preLoaderRoute: typeof WorkspaceWorkspaceIdChatBotDataChatBotDataIdChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/chatBotData/$chatBotDataId/publicChat': {
      id: '/workspace/$workspaceId/chatBotData/$chatBotDataId/publicChat'
      path: '/workspace/$workspaceId/chatBotData/$chatBotDataId/publicChat'
      fullPath: '/workspace/$workspaceId/chatBotData/$chatBotDataId/publicChat'
      preLoaderRoute: typeof WorkspaceWorkspaceIdChatBotDataChatBotDataIdPublicChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/': {
      id: '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/'
      path: '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId'
      fullPath: '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/': {
      id: '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/'
      path: '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId'
      fullPath: '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/botProvider/$botProviderId/user/$userId': {
      id: '/workspace/$workspaceId/botProvider/$botProviderId/user/$userId'
      path: '/workspace/$workspaceId/botProvider/$botProviderId/user/$userId'
      fullPath: '/workspace/$workspaceId/botProvider/$botProviderId/user/$userId'
      preLoaderRoute: typeof WorkspaceWorkspaceIdBotProviderBotProviderIdUserUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/$dataId/': {
      id: '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/$dataId/'
      path: '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/$dataId'
      fullPath: '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/$dataId/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdDataIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/': {
      id: '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/'
      path: '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId'
      fullPath: '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/report': {
      id: '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/report'
      path: '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/report'
      fullPath: '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/report'
      preLoaderRoute: typeof WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdReportRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface WorkspaceWorkspaceIdSettingsRouteChildren {
  WorkspaceWorkspaceIdSettingsInfoRoute: typeof WorkspaceWorkspaceIdSettingsInfoRoute
  WorkspaceWorkspaceIdSettingsPendingUsersRoute: typeof WorkspaceWorkspaceIdSettingsPendingUsersRoute
  WorkspaceWorkspaceIdSettingsUsersRoute: typeof WorkspaceWorkspaceIdSettingsUsersRoute
}

const WorkspaceWorkspaceIdSettingsRouteChildren: WorkspaceWorkspaceIdSettingsRouteChildren =
  {
    WorkspaceWorkspaceIdSettingsInfoRoute:
      WorkspaceWorkspaceIdSettingsInfoRoute,
    WorkspaceWorkspaceIdSettingsPendingUsersRoute:
      WorkspaceWorkspaceIdSettingsPendingUsersRoute,
    WorkspaceWorkspaceIdSettingsUsersRoute:
      WorkspaceWorkspaceIdSettingsUsersRoute,
  }

const WorkspaceWorkspaceIdSettingsRouteWithChildren =
  WorkspaceWorkspaceIdSettingsRoute._addFileChildren(
    WorkspaceWorkspaceIdSettingsRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SettingsRoute: SettingsRoute,
  AdminLoginRoute: AdminLoginRoute,
  ChatCreditKeyIndexRoute: ChatCreditKeyIndexRoute,
  WorkspaceIndexRoute: WorkspaceIndexRoute,
  AdminUserManagerUserIdRoute: AdminUserManagerUserIdRoute,
  WorkspaceWorkspaceIdSettingsRoute:
    WorkspaceWorkspaceIdSettingsRouteWithChildren,
  AdminUserManagerIndexRoute: AdminUserManagerIndexRoute,
  AdminWorkspaceManagerIndexRoute: AdminWorkspaceManagerIndexRoute,
  WorkspaceWorkspaceIdIndexRoute: WorkspaceWorkspaceIdIndexRoute,
  WorkspaceWorkspaceIdBotProviderIndexRoute:
    WorkspaceWorkspaceIdBotProviderIndexRoute,
  WorkspaceWorkspaceIdChatBotDataIndexRoute:
    WorkspaceWorkspaceIdChatBotDataIndexRoute,
  WorkspaceWorkspaceIdChatEvaluationTestSetIndexRoute:
    WorkspaceWorkspaceIdChatEvaluationTestSetIndexRoute,
  WorkspaceWorkspaceIdEmbeddingCollectionIndexRoute:
    WorkspaceWorkspaceIdEmbeddingCollectionIndexRoute,
  WorkspaceWorkspaceIdNotificationSettingsIndexRoute:
    WorkspaceWorkspaceIdNotificationSettingsIndexRoute,
  WorkspaceWorkspaceIdBotProviderBotProviderIdFeedbackRoute:
    WorkspaceWorkspaceIdBotProviderBotProviderIdFeedbackRoute,
  WorkspaceWorkspaceIdBotProviderBotProviderIdHistoryRoute:
    WorkspaceWorkspaceIdBotProviderBotProviderIdHistoryRoute,
  WorkspaceWorkspaceIdChatBotDataChatBotDataIdChatRoute:
    WorkspaceWorkspaceIdChatBotDataChatBotDataIdChatRoute,
  WorkspaceWorkspaceIdChatBotDataChatBotDataIdPublicChatRoute:
    WorkspaceWorkspaceIdChatBotDataChatBotDataIdPublicChatRoute,
  WorkspaceWorkspaceIdBotProviderBotProviderIdIndexRoute:
    WorkspaceWorkspaceIdBotProviderBotProviderIdIndexRoute,
  WorkspaceWorkspaceIdChatBotDataChatBotDataIdIndexRoute:
    WorkspaceWorkspaceIdChatBotDataChatBotDataIdIndexRoute,
  WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdIndexRoute:
    WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdIndexRoute,
  WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdIndexRoute:
    WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdIndexRoute,
  WorkspaceWorkspaceIdBotProviderBotProviderIdUserUserIdRoute:
    WorkspaceWorkspaceIdBotProviderBotProviderIdUserUserIdRoute,
  WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdDataIdIndexRoute:
    WorkspaceWorkspaceIdEmbeddingCollectionEmbeddingCollectionIdDataIdIndexRoute,
  WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdReportRoute:
    WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdReportRoute,
  WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdIndexRoute:
    WorkspaceWorkspaceIdChatEvaluationTestSetChatEvaluationTestSetIdTestChatEvaluationTestIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
